import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';


const adminTableHeader = [
  { id: 'branddescription', label: 'MARCA' },
  { id: 'modeldescription', label: 'MODELO' },
  { id: 'version', label: 'VERSÃO' },
  { id: 'brandcode', label: 'CÓDIGO MARCA' },
  { id: 'modelcode', label: 'CÓDIGO MODELO' },
  { id: 'isnew', label: 'NOVO' },
  { id: 'isused', label: 'USADO' }
];

const styles = ({
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px'
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  }
});


class AdminBrandModelTableHeader extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, classes } = this.props;
    return (
      <TableHead className={classes.tblHead} >
        <TableRow className={classes.headerHeight} >
          {adminTableHeader.map(column => {
            return (
              <TableCell
                key={column.id}
                padding='none'
                sortDirection={orderBy === column.id ? order : false}
                className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, classes.cellPadding)}
              >
                <TableSortLabel
                  className={classes.tblHeadT}
                  active={orderBy === column.id}
                  direction={order}
                  onClick={this.createSortHandler(column.id)}
                  classes={{ icon: classes.tblSort }}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

AdminBrandModelTableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired
};

export default AdminBrandModelTableHeader = withStyles(styles)(AdminBrandModelTableHeader);


// WEBPACK FOOTER //
// ./src/components/Administration/AdminBrandModel/AdminBrandModelTableHeader.js